// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Carousel_wrapper__CPhyz","bleed":"Carousel_bleed__yU_Ch","carousel":"Carousel_carousel__DVQ_O","controls":"Carousel_controls__s7V0L","loading":"Carousel_loading__OGBWt"};